import {useMemo} from "react";

const useCountry = (): string => useMemo<string>(() => process.env.REACT_APP_COUNTRY || "RU", []);

export default useCountry;